export const supportedLngs = ["en", "fr", "es", "de", "pt", "it"];
export const localizationBackend =
  "https://intl.infra.keezoku.com/api/translations";
export const localizationProjectId = "mf4wl9u98oi9cld0vjf0bofs";
